import common from './common'

const homeContentShowKfmt = 'duba_jgpdf_invoice:7930 page_show:byte click:byte source:byte item1:byte item2:byte item3:byte'

export default {
  API: {
    method1 () {
    }
  },
  REPORT: {

    /** 电子发票展示 点击 */
    reportElectronicInvoiceClickandShow (params) {
      const info = {
        page_show: 0, // 1-发票首页 2-扫码开票页
        click: 0, // 点击 1-开具发票2-开发票中3-发票完成
        source: 0, // 页面展示来源：1-会员中心右上角2-点击会员头像
        item1: 0,
        item2: 0,
        item3: 0,
      }
      return common.REPORT.client_report_by_kfmt(homeContentShowKfmt, common.API.replaceObj(info, params))
    }
  }
}
